<template>
  <div v-if="scaling">
    <v-row>
      <v-col cols="6">
        <validation-provider :vid="uuid()" name="X" rules="required" v-slot="v">
          <v-text-field label="X" v-model.number="cScaling.x" @input="updateScaling"></v-text-field>
          <span class="validation-message">{{ v.errors[0] }}</span>
        </validation-provider>
      </v-col>

      <v-col cols="6">
        <validation-provider :vid="uuid()" name="Y" rules="required" v-slot="v">
          <v-text-field label="Y" v-model.number="cScaling.y" @input="updateScaling"></v-text-field>
          <span class="validation-message">{{ v.errors[0] }}</span>
        </validation-provider>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import { cloneDeep } from "lodash";
import uuid from "src/mixins/uuid";

export default {
  components: { ValidationProvider },
  props: ["scaling"],
  mixins: [uuid],
  data() {
    return {
      cScaling: cloneDeep(this.scaling)
    };
  },
  watch: {
    scaling: {
      handler(newValue) {
        this.cScaling = cloneDeep(newValue);
      },
      deep: true
    }
  },
  methods: {
    reloadData(data) {
      this.cScaling = cloneDeep(data);
    },
    updateScaling() {
      this.$emit("update", cloneDeep(this.cScaling));
    }
  }
};
</script>
